// import React, { useEffect, useState } from 'react';
// import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
// import { BarChart, Bar, PieChart, Pie, RadarChart, Radar, PolarGrid, PolarAngleAxis, 
//   PolarRadiusAxis, XAxis, YAxis, Tooltip, Legend, Cell, ResponsiveContainer } from 'recharts';
// import createInstance from '../../../api/axiosinstance';
// import { useSelector } from 'react-redux';

// export default function HRcandidate() {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const aiDisha = createInstance("DISHA");
//   const organizationId = user?.organizationId
//   const [dashboardData, setDashboardData] = useState({
//     totalInterviews: 0,
//     pipelineCandidates: 0,
//     hirePercentage: 0,
//     strongHirePercentage: 0,
//     borderlinePercentage: 0,
//     noHirePercentage: 0,
//     pipelinePercentage: 0,
//     averageScores: {}
//   });
//   const [averageScores, setAverageScores] = useState({
//     technical_knowledge: 0,
//     hands_on_skills: 0,
//     problem_solving: 0,
//     communication_skills: 0,
//     culture_fit: 0
//   });

//   useEffect(()=>{
//     Dashboard()
//   },[])

//   const Dashboard = async () => {
//     try {
//       const response = await aiDisha.get(`/hr_dashboard?organization_id=${organizationId}`);
//       console.log("dashboard", response.data.average_graph_val);
      
//       // Extract data from API response
//       const data = response.data;
//       const avgScores = data.average_graph_val[0]?.average_scores || {};
      
//       // Set state with API data
//       setDashboardData({
//         totalInterviews: data['total interviews'] || 0,
//         pipelineCandidates: data['pipeline_candidates'] || 0,
//         hirePercentage: data['hire_percentage'] || 0,
//         strongHirePercentage: data['strong_hire_percentage'] || 0,
//         borderlinePercentage: data['borderline_percentage'] || 0,
//         noHirePercentage: data['no_hire_percentage'] || 0,
//         pipelinePercentage: data['pipeline_percentage'] || 0,
//       });

//      // Update average scores state
//      setAverageScores({
//        technical_knowledge: avgScores.technical_knowledge || 0,
//        hands_on_skills: avgScores.hands_on_skills || 0,
//        problem_solving: avgScores.problem_solving || 0,
//        communication_skills: avgScores.communication_skills || 0,
//        culture_fit: avgScores.culture_fit || 0
//      });
//     } catch (error) {
//       console.log("error", error);
//     }
//   };


//   useEffect(() => {
//     console.log("Updated dashboard data:", dashboardData);
//   }, [dashboardData]);
//   // Data for Stats Cards
//   const statsData = [
//     { title: "Total Interviews", value: dashboardData.totalInterviews },
//     { title: "Avg Score", value: "3.9 / 5" },
//     { title: "Selection Percentage", value: dashboardData.hirePercentage },
//     { title: "Pipeline Candidates", value: dashboardData.pipelineCandidates }
//   ];

//   // Data for Bar Chart
//   const scoreData = [
//     { name: 'Technical', score: averageScores.technical_knowledge },
//     { name: 'Hands-on', score: averageScores.hands_on_skills },
//     { name: 'Problem Solving', score: averageScores.problem_solving },
//     { name: 'Communication', score: averageScores.communication_skills },
//     { name: 'Culture Fit', score: averageScores.culture_fit }
//   ];

//   // Data for Pie Chart
//   const decisionData = [
//     { name: 'Strong Hire', value: dashboardData.strongHirePercentage, color: '#2e7d32' },
//     { name: 'Hire', value: dashboardData.hirePercentage, color: '#1976d2' },
//     { name: 'Borderline', value: dashboardData.borderlinePercentage, color: '#ed6c02' },
//     { name: 'No Hire', value: dashboardData.noHirePercentage, color: '#d32f2f' },
//     { name: 'Pipeline', value: dashboardData.pipelinePercentage, color: '#757575' }
//   ];

//   // Data for Radar Chart
//   const skillData = [
//     { subject: 'Coding', A: 4.0, fullMark: 5 },
//     { subject: 'System Design', A: 3.5, fullMark: 5 },
//     { subject: 'API Knowledge', A: 3.8, fullMark: 5 },
//     { subject: 'CI/CD Tools', A: 3.2, fullMark: 5 },
//     { subject: 'Communication', A: 4.1, fullMark: 5 }
//   ];

//   return (
//     <Container sx={{ my: 5,color:"#033538" }}>
//       <Typography variant="h4" component="h2" align="center" gutterBottom sx={{ mb: 4 }} >
//         HR Interview Analytics Dashboard
//       </Typography>

//       {/* Stats Cards */}
//       <Grid container spacing={3} sx={{ mb: 4 }}>
//         {statsData.map((stat, index) => (
//           <Grid item xs={12} sm={6} md={3} key={index}>
//             <Card elevation={2} sx={{ height: '100%' }}>
//               <CardContent sx={{ textAlign: 'center' }}>
//                 <Typography variant="h6" color="text.secondary" gutterBottom>
//                   {stat.title}
//                 </Typography>
//                 <Typography variant="h4" component="div" color="#033538">
//                   {stat.value}
//                 </Typography>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Score Distribution */}
//       <Card elevation={1} sx={{ mb: 4, p: 2 }}>
//         <CardContent>
//           <Typography variant="h6" gutterBottom color="text.secondary">
//             Average Score per Category
//           </Typography>
//           <Box sx={{ height: 300 }}>
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart
//                 data={scoreData}
//                 margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
//               >
//                 <XAxis dataKey="name" />
//                 <YAxis domain={[0, 5]} />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="score" fill="#1976d2" name="Avg Score (1-5)" />
//               </BarChart>
//             </ResponsiveContainer>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Decision Summary */}
//       <Card elevation={1} sx={{ mb: 4, p: 2 }}>
//         <CardContent>
//           <Typography variant="h6" gutterBottom color="text.secondary">
//             Candidate Decision Breakdown
//           </Typography>
//           <Box sx={{ height: 300 }}>
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={decisionData}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={true}
//                   label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//                   outerRadius={80}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {decisionData.map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={entry.color} />
//                   ))}
//                 </Pie>
//                 <Tooltip formatter={(value) => `${value} candidates`} />
//                 <Legend />
//               </PieChart>
//             </ResponsiveContainer>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Skill Radar */}
//       <Card elevation={1} sx={{ p: 2 }}>
//         <CardContent>
//           <Typography variant="h6" gutterBottom color="text.secondary">
//             Skill Radar: Candidate Strengths
//           </Typography>
//           <Box sx={{ height: 300 }}>
//             <ResponsiveContainer width="100%" height="100%">
//               <RadarChart cx="50%" cy="50%" outerRadius="80%" data={skillData}>
//                 <PolarGrid />
//                 <PolarAngleAxis dataKey="subject" />
//                 <PolarRadiusAxis domain={[0, 5]} />
//                 <Radar
//                   name="Average Candidate Skill"
//                   dataKey="A"
//                   stroke="#1976d2"
//                   fill="#1976d2"
//                   fillOpacity={0.3}
//                 />
//                 <Tooltip />
//                 <Legend />
//               </RadarChart>
//             </ResponsiveContainer>
//           </Box>
//         </CardContent>
//       </Card>
//     </Container>
//   );
// }













































import React, { useState, useEffect } from "react";
import {
  Box, Grid, Card, CardContent, Typography, Chip, LinearProgress,
  Divider, IconButton, Tooltip, Avatar, Stack, Paper, Skeleton, Alert, Button,
} from "@mui/material";
import {
  RefreshOutlined, ErrorOutlineOutlined, TrendingUp, PeopleAlt,
  CheckCircleOutline, ThumbUpOutlined, ThumbDownOutlined,
  RemoveCircleOutline, HourglassEmptyOutlined, StarOutlined,
  BarChartOutlined, GroupsOutlined,
} from "@mui/icons-material";
import { useThemeMode } from "../../Themes/ThemeContextTemp";
import createInstance from "../../../api/axiosinstance";

// ─── Empty fallback ───────────────────────────────────────────────────────────
const EMPTY_DATA = {
  average_graph_val: [
    {
      average_scores: {
        technical_knowledge: 0,
        hands_on_skills: 0,
        problem_solving: 0,
        communication_skills: 0,
        culture_fit: 0,
        overall_average: 0,
        total_candidates: 0,
      },
    },
  ],
  "total interviews": 0,
  pipeline_candidates: 0,
  hire_percentage: 0,
  strong_hire_percentage: 0,
  pipeline_percentage: 0,
  borderline_percentage: 0,
  no_hire_percentage: 0,
};

const mapHRData = (api = {}) => {
  const scores = api.average_graph_val?.[0]?.average_scores ?? {};
  return {
    scores: {
      technical_knowledge:  scores.technical_knowledge  ?? 0,
      hands_on_skills:      scores.hands_on_skills      ?? 0,
      problem_solving:      scores.problem_solving       ?? 0,
      communication_skills: scores.communication_skills ?? 0,
      culture_fit:          scores.culture_fit           ?? 0,
      overall_average:      scores.overall_average       ?? 0,
      total_candidates:     scores.total_candidates      ?? 0,
    },
    total_interviews:        api["total interviews"]      ?? 0,
    pipeline_candidates:     api.pipeline_candidates      ?? 0,
    hire_percentage:         api.hire_percentage          ?? 0,
    strong_hire_percentage:  api.strong_hire_percentage   ?? 0,
    pipeline_percentage:     api.pipeline_percentage      ?? 0,
    borderline_percentage:   api.borderline_percentage    ?? 0,
    no_hire_percentage:      api.no_hire_percentage       ?? 0,
  };
};

// ─── Skeleton card ────────────────────────────────────────────────────────────
function MetricCardSkeleton({ COLORS }) {
  return (
    <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3 }}>
      <Box sx={{ height: 3, background: COLORS.border, borderRadius: "12px 12px 0 0" }} />
      <CardContent sx={{ p: 2.2 }}>
        <Skeleton width="60%" height={14} sx={{ mb: 1 }} />
        <Skeleton width="40%" height={36} sx={{ mb: 0.5 }} />
        <Skeleton width="80%" height={12} />
      </CardContent>
    </Card>
  );
}

// ─── KPI card ─────────────────────────────────────────────────────────────────
function MetricCard({ label, value, sub, icon: Icon, accentColor, COLORS }) {
  return (
    <Card elevation={0} sx={{
      background: COLORS.cardBg, border: `1px solid ${COLORS.border}`,
      borderRadius: 3, height: "100%", overflow: "hidden",
      transition: "transform 0.18s, box-shadow 0.18s",
      "&:hover": { transform: "translateY(-2px)", boxShadow: `0 6px 24px ${accentColor}22` },
    }}>
      <Box sx={{ height: 3, background: accentColor, borderRadius: "12px 12px 0 0" }} />
      <CardContent sx={{ p: 2.2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mb: 0.6, letterSpacing: 0.3 }}>{label}</Typography>
            <Typography sx={{ fontSize: 28, fontWeight: 700, color: COLORS.text, lineHeight: 1 }}>{value}</Typography>
            {sub && <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mt: 0.8 }}>{sub}</Typography>}
          </Box>
          <Avatar sx={{ width: 38, height: 38, borderRadius: 2, background: `${accentColor}18` }}>
            <Icon sx={{ fontSize: 18, color: accentColor }} />
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
}

// ─── Section label ────────────────────────────────────────────────────────────
function SectionLabel({ children, COLORS }) {
  return (
    <Typography sx={{
      fontSize: 10, fontWeight: 700, letterSpacing: 1,
      color: COLORS.card_txt_color, textTransform: "uppercase", mb: 1.2, mt: 0.5,
    }}>{children}</Typography>
  );
}

// ─── Horizontal score bar ─────────────────────────────────────────────────────
function ScoreBar({ label, value, max = 5, color, COLORS }) {
  const pct = max > 0 ? Math.round((value / max) * 100) : 0;
  return (
    <Box sx={{ mb: 1.6 }}>
      <Stack direction="row" justifyContent="space-between" mb={0.5}>
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: COLORS.text }}>{label}</Typography>
        <Chip
          label={`${value} / ${max}`}
          size="small"
          sx={{ height: 18, fontSize: 10, fontWeight: 700, background: `${color}18`, color }}
        />
      </Stack>
      <LinearProgress variant="determinate" value={pct} sx={{
        height: 8, borderRadius: 4,
        backgroundColor: "rgba(128,128,128,0.12)",
        "& .MuiLinearProgress-bar": {
          background: `linear-gradient(90deg, ${color}, ${color}bb)`, borderRadius: 4,
        },
      }} />
    </Box>
  );
}

// ─── Donut segment arc (SVG) ──────────────────────────────────────────────────
function PieDonut({ segments, size = 120, thickness = 14, COLORS }) {
  const r = (size - thickness) / 2;
  const cx = size / 2, cy = size / 2;
  const circumference = 2 * Math.PI * r;

  let offset = 0;
  const arcs = segments
    .filter((s) => s.pct > 0)
    .map((s) => {
      const dash = (s.pct / 100) * circumference;
      const arc = { ...s, dash, offset, circumference };
      offset += dash;
      return arc;
    });

  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle cx={cx} cy={cy} r={r} fill="none"
        stroke="rgba(128,128,128,0.12)" strokeWidth={thickness} />
      {arcs.map((a) => (
        <circle key={a.label} cx={cx} cy={cy} r={r} fill="none"
          stroke={a.color} strokeWidth={thickness}
          strokeDasharray={`${a.dash} ${a.circumference - a.dash}`}
          strokeDashoffset={-a.offset}
          strokeLinecap="butt"
          style={{ transition: "stroke-dasharray 0.6s ease" }}
        />
      ))}
    </svg>
  );
}

// ─── Percentage badge row ─────────────────────────────────────────────────────
function PctRow({ label, pct, color, COLORS }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center"
      sx={{ py: 0.9, borderBottom: `0.5px solid ${COLORS.border}` }}>
      <Stack direction="row" alignItems="center" gap={0.8}>
        <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: color, flexShrink: 0 }} />
        <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>{label}</Typography>
      </Stack>
      <Chip label={`${pct}%`} size="small"
        sx={{ height: 20, fontSize: 11, fontWeight: 700, background: `${color}18`, color }} />
    </Stack>
  );
}

// ─── Overall score ring ───────────────────────────────────────────────────────
function OverallRing({ score, max = 5, accent, COLORS }) {
  const pct = max > 0 ? (score / max) * 100 : 0;
  const r = 44, c = 2 * Math.PI * r, dash = (pct / 100) * c;
  return (
    <Box sx={{ position: "relative", width: 104, height: 104, flexShrink: 0 }}>
      <svg width="104" height="104" style={{ transform: "rotate(-90deg)" }}>
        <circle cx="52" cy="52" r={r} fill="none" stroke="rgba(128,128,128,0.12)" strokeWidth="12" />
        <circle cx="52" cy="52" r={r} fill="none" stroke={accent} strokeWidth="12"
          strokeDasharray={`${dash} ${c - dash}`} strokeLinecap="round"
          style={{ transition: "stroke-dasharray 0.8s ease" }} />
      </svg>
      <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Typography sx={{ fontSize: 18, fontWeight: 800, color: COLORS.text, lineHeight: 1 }}>{score}</Typography>
        <Typography sx={{ fontSize: 9, color: COLORS.card_txt_color }}>/ {max}</Typography>
      </Box>
    </Box>
  );
}

// ─── Main Dashboard ───────────────────────────────────────────────────────────
export default function HRDashboard() {
  const { COLORS, theme, toggleTheme } = useThemeMode();
  const axiosInstance = createInstance("DISHA");

  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const ORG_ID = "ORGID000001"; // Replace with dynamic org ID from context/props/URL

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axiosInstance.get(`/hr_dashboard?organization_id=${ORG_ID}`);
      setData(mapHRData(response.data));
    } catch (err) {
      console.error("HR dashboard fetch error:", err);
      setError("Unable to load HR dashboard data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchDashboard(); }, []);

  const d = data ?? mapHRData(EMPTY_DATA);

  const accent = theme === "dark" ? "#e6b450" : "rgb(37,99,235)";
  const purple = "#7c3aed";
  const teal   = "#0d9488";
  const green  = "#16a34a";
  const amber  = "#d97706";
  const red    = "#dc2626";
  const sky    = "#0284c7";

  const kpiCards = [
    { label: "Total Interviews",    value: d.total_interviews,       sub: "All interview records",          icon: GroupsOutlined,        color: accent  },
    { label: "Pipeline Candidates", value: d.pipeline_candidates,    sub: "Currently in pipeline",          icon: HourglassEmptyOutlined, color: purple  },
    { label: "Total Candidates",    value: d.scores.total_candidates, sub: "Evaluated",                     icon: PeopleAlt,             color: teal    },
    { label: "Overall Avg Score",   value: d.scores.overall_average, sub: "Out of 5 across all criteria",   icon: StarOutlined,          color: amber   },
  ];

  const decisionSegments = [
    { label: "Strong Hire",  pct: d.strong_hire_percentage,  color: green   },
    { label: "Hire",         pct: d.hire_percentage,         color: sky     },
    { label: "Borderline",   pct: d.borderline_percentage,   color: amber   },
    { label: "No Hire",      pct: d.no_hire_percentage,      color: red     },
    { label: "Pipeline",     pct: d.pipeline_percentage,     color: purple  },
  ];

  const scoreColors = [accent, purple, teal, amber, sky];
  const scoreFields = [
    { key: "technical_knowledge",  label: "Technical Knowledge"  },
    { key: "hands_on_skills",      label: "Hands-on Skills"      },
    { key: "problem_solving",      label: "Problem Solving"      },
    { key: "communication_skills", label: "Communication Skills" },
    { key: "culture_fit",          label: "Culture Fit"          },
  ];

  if (error && !data) {
    return (
      <Box sx={{ background: COLORS.background, minHeight: "100vh", p: 3,
        display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, background: COLORS.cardBg,
          border: `1px solid ${COLORS.border}`, textAlign: "center", maxWidth: 420 }}>
          <Avatar sx={{ width: 56, height: 56, borderRadius: 2,
            background: "rgba(220,38,38,0.1)", mx: "auto", mb: 2 }}>
            <ErrorOutlineOutlined sx={{ fontSize: 28, color: "#dc2626" }} />
          </Avatar>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: COLORS.text, mb: 1 }}>
            Failed to load HR dashboard
          </Typography>
          <Typography sx={{ fontSize: 12, color: COLORS.card_txt_color, mb: 2.5, lineHeight: 1.6 }}>
            {error}
          </Typography>
          <Button variant="outlined" startIcon={<RefreshOutlined />} onClick={fetchDashboard}
            sx={{ borderColor: accent, color: accent, borderRadius: 2, textTransform: "none", fontWeight: 600 }}>
            Retry
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ background: COLORS.background, minHeight: "100vh", p: { xs: 2, md: 3 } }}>

      {error && data && (
        <Alert severity="warning"
          action={<Button size="small" onClick={fetchDashboard}>Retry</Button>}
          sx={{ mb: 2, borderRadius: 2, fontSize: 12 }}>
          Could not refresh — showing last loaded values.
        </Alert>
      )}

      {/* ── Top bar ── */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Avatar sx={{ width: 40, height: 40, borderRadius: 2, background: accent }}>
            <BarChartOutlined sx={{ fontSize: 20, color: "white" }} />
          </Avatar>
          <Box>
            <Typography sx={{ fontSize: 16, fontWeight: 700, color: COLORS.text, lineHeight: 1.2 }}>
              HR Dashboard
            </Typography>
            <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>
              {ORG_ID} · Hiring Analytics
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          <Chip label={loading ? "Loading…" : "● Live"} size="small" sx={{
            fontSize: 11, fontWeight: 600, height: 24,
            background: loading ? "rgba(107,114,128,0.12)" : "rgba(22,163,74,0.12)",
            color: loading ? "#6b7280" : "#16a34a",
          }} />
          <Tooltip title="Refresh">
            <span>
              <IconButton onClick={fetchDashboard} disabled={loading} size="small" sx={{
                border: `1px solid ${COLORS.border}`, background: COLORS.cardBg,
                color: COLORS.text, borderRadius: 2, width: 34, height: 34,
              }}>
                <RefreshOutlined sx={{ fontSize: 16, ...(loading && { animation: "spin 1s linear infinite" }) }} />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}>
            <IconButton onClick={toggleTheme} size="small" sx={{
              border: `1px solid ${COLORS.border}`, background: COLORS.cardBg,
              color: COLORS.text, borderRadius: 2, width: 34, height: 34,
            }}>
              {theme === "dark" ? "☀️" : "🌙"}
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      {/* ── KPI Cards ── */}
      <SectionLabel COLORS={COLORS}>Overview metrics</SectionLabel>
      <Grid container spacing={1.5} mb={2.5}>
        {loading
          ? Array.from({ length: 4 }).map((_, i) => (
              <Grid item xs={6} sm={3} key={i}><MetricCardSkeleton COLORS={COLORS} /></Grid>
            ))
          : kpiCards.map((k) => (
              <Grid item xs={6} sm={3} key={k.label}>
                <MetricCard {...k} accentColor={k.color} COLORS={COLORS} />
              </Grid>
            ))
        }
      </Grid>

      {/* ── Middle row ── */}
      <Grid container spacing={1.5} mb={2.5}>

        {/* Candidate Scores */}
        <Grid item xs={12} md={5}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>
                  Candidate Score Breakdown
                </Typography>
                <Chip label={`${d.scores.total_candidates} evaluated`} size="small"
                  sx={{ fontSize: 10, fontWeight: 600, height: 20, background: `${accent}18`, color: accent }} />
              </Stack>

              {/* Overall ring + label */}
              {loading ? (
                <Stack direction="row" alignItems="center" gap={2} mb={2.5}>
                  <Skeleton variant="circular" width={104} height={104} />
                  <Box><Skeleton width={120} height={18} /><Skeleton width={160} height={13} sx={{ mt: 0.5 }} /></Box>
                </Stack>
              ) : (
                <Stack direction="row" alignItems="center" gap={2} mb={2.5}>
                  <OverallRing score={d.scores.overall_average} max={5} accent={accent} COLORS={COLORS} />
                  <Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: COLORS.text }}>Overall Average</Typography>
                    <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mt: 0.4, lineHeight: 1.5 }}>
                      Composite score across all<br />evaluation criteria
                    </Typography>
                  </Box>
                </Stack>
              )}

              <Divider sx={{ my: 1.5, borderColor: COLORS.border }} />

              {loading
                ? scoreFields.map((_, i) => (
                    <Box key={i} mb={1.8}>
                      <Skeleton width="55%" height={13} sx={{ mb: 0.5 }} />
                      <Skeleton height={10} />
                    </Box>
                  ))
                : scoreFields.map((f, i) => (
                    <ScoreBar
                      key={f.key}
                      label={f.label}
                      value={d.scores[f.key]}
                      max={5}
                      color={scoreColors[i % scoreColors.length]}
                      COLORS={COLORS}
                    />
                  ))
              }
            </CardContent>
          </Card>
        </Grid>

        {/* Decision Distribution */}
        <Grid item xs={12} md={4}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text, mb: 2 }}>
                Decision Distribution
              </Typography>

              {/* Donut */}
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                {loading
                  ? <Skeleton variant="circular" width={120} height={120} />
                  : <PieDonut segments={decisionSegments} size={120} thickness={14} COLORS={COLORS} />
                }
              </Box>

              {/* Legend rows */}
              {decisionSegments.map((s) => (
                loading
                  ? null
                  : <PctRow key={s.label} label={s.label} pct={s.pct} color={s.color} COLORS={COLORS} />
              ))}

              {loading && [1,2,3,4,5].map((i) => (
                <Stack key={i} direction="row" justifyContent="space-between" sx={{ py: 0.9 }}>
                  <Skeleton width="50%" height={14} />
                  <Skeleton width={36} height={20} variant="rounded" />
                </Stack>
              ))}

              <Divider sx={{ my: 2, borderColor: COLORS.border }} />

              {/* Hire health */}
              <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, background: `${green}10`, border: `1px solid ${green}22` }}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: green, mb: 0.4 }}>Hire Signal</Typography>
                <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, lineHeight: 1.6 }}>
                  {loading
                    ? "Calculating…"
                    : (d.hire_percentage + d.strong_hire_percentage) > 50
                      ? `${d.hire_percentage + d.strong_hire_percentage}% candidates are hire-ready. Strong pipeline.`
                      : d.borderline_percentage > 50
                        ? `${d.borderline_percentage}% are borderline. Consider additional screening rounds.`
                        : `${d.no_hire_percentage}% are no-hire. Review evaluation criteria.`
                  }
                </Typography>
              </Paper>
            </CardContent>
          </Card>
        </Grid>

        {/* Quick stats */}
        <Grid item xs={12} md={3}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text, mb: 2 }}>
                Hiring Funnel
              </Typography>

              {[
                { label: "Strong Hire",       val: `${d.strong_hire_percentage}%`,  color: green,  icon: ThumbUpOutlined        },
                { label: "Hire",              val: `${d.hire_percentage}%`,         color: sky,    icon: CheckCircleOutline     },
                { label: "Borderline",        val: `${d.borderline_percentage}%`,   color: amber,  icon: RemoveCircleOutline    },
                { label: "No Hire",           val: `${d.no_hire_percentage}%`,      color: red,    icon: ThumbDownOutlined      },
                { label: "Pipeline",          val: `${d.pipeline_percentage}%`,     color: purple, icon: HourglassEmptyOutlined },
              ].map((r) => (
                <Stack key={r.label} direction="row" justifyContent="space-between" alignItems="center"
                  sx={{ py: 1.1, borderBottom: `0.5px solid ${COLORS.border}` }}>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 28, height: 28, borderRadius: 1.5, background: `${r.color}18` }}>
                      <r.icon sx={{ fontSize: 13, color: r.color }} />
                    </Avatar>
                    <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>{r.label}</Typography>
                  </Stack>
                  {loading
                    ? <Skeleton width={40} height={22} variant="rounded" />
                    : <Chip label={r.val} size="small"
                        sx={{ height: 22, fontSize: 12, fontWeight: 700, background: `${r.color}18`, color: r.color }} />
                  }
                </Stack>
              ))}

              <Divider sx={{ my: 2, borderColor: COLORS.border }} />

              <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, background: `${accent}10`, border: `1px solid ${accent}22` }}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: accent, mb: 0.4 }}>Pipeline Status</Typography>
                <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, lineHeight: 1.6 }}>
                  {loading
                    ? "Checking…"
                    : d.pipeline_candidates > 0
                      ? `${d.pipeline_candidates} candidate${d.pipeline_candidates > 1 ? "s" : ""} currently in active pipeline.`
                      : "No candidates currently in the pipeline."
                  }
                </Typography>
              </Paper>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* ── Score radar summary ── */}
      <SectionLabel COLORS={COLORS}>Evaluation snapshot</SectionLabel>
      <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, mb: 2 }}>
        <CardContent sx={{ p: 2.5 }}>
          <Grid container spacing={2} alignItems="center">
            {scoreFields.map((f, i) => {
              const val = d.scores[f.key];
              const color = scoreColors[i % scoreColors.length];
              const pct = Math.round((val / 5) * 100);
              return (
                <Grid item xs={6} sm={4} md key={f.key}>
                  <Box sx={{ textAlign: "center" }}>
                    {loading ? (
                      <>
                        <Skeleton variant="circular" width={52} height={52} sx={{ mx: "auto", mb: 0.6 }} />
                        <Skeleton width={80} height={12} sx={{ mx: "auto" }} />
                      </>
                    ) : (
                      <>
                        <Box sx={{ position: "relative", width: 52, height: 52, mx: "auto", mb: 0.6 }}>
                          <svg width="52" height="52" style={{ transform: "rotate(-90deg)" }}>
                            <circle cx="26" cy="26" r="20" fill="none" stroke="rgba(128,128,128,0.12)" strokeWidth="6" />
                            <circle cx="26" cy="26" r="20" fill="none" stroke={color} strokeWidth="6"
                              strokeDasharray={`${(pct / 100) * 2 * Math.PI * 20} ${2 * Math.PI * 20}`}
                              strokeLinecap="round"
                              style={{ transition: "stroke-dasharray 0.6s ease" }}
                            />
                          </svg>
                          <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
                            display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Typography sx={{ fontSize: 12, fontWeight: 800, color: COLORS.text }}>{val}</Typography>
                          </Box>
                        </Box>
                        <Typography sx={{ fontSize: 10, color: COLORS.card_txt_color, textAlign: "center", lineHeight: 1.3 }}>
                          {f.label}
                        </Typography>
                      </>
                    )}
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </CardContent>
      </Card>

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </Box>
  );
}